// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resend {
  width: fit-content;
}
.resend .message {
  font-size: 0.75rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/Auth/Otp/ResendCode/resend.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AACI;EACI,kBAAA;AACR","sourcesContent":[".resend {\n    width: fit-content;\n\n    .message {\n        font-size: 0.75rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
